import React from "react";

import "./card.scss";

const ICard = ({children, cardClass}) => {

    return(
        <div className={`common-card ${cardClass}`}>
  
  <div className="px-6 py-4">
    
   {children}
  </div>
 
</div>
    )

}

export default ICard;
